<template>
  <div>
  </div>
</template>
<script>
export default {
  name: 'DefaultSidebarHeader'
}
</script>
